import moment from 'moment';

const localeDict = {
    'ar': 'العربية',
    'sv-SE': 'Svenska',
    'en-US': 'English',
};

const rtlLocateDict = ['he', 'ar'];

export function formatLocale(locale) {
    return localeDict[locale] || 'English';
}

export function isRTL(locale) {
    return locale && rtlLocateDict.indexOf(locale) >= 0;
}

export function generateMomentLocaleSettings(locale) {
    var localeData = moment.localeData('en');
    let response = {
        ordinal: localeData.ordinal()
    };
    return response;
}